import axios from "axios";
import jsonBig from "json-bigint";
import context from "../main.js";
import { Toast } from "vant";
import { Message } from "element-ui";
import storage from "./storage.js";

const service = axios.create({
  baseURL:
    window.location.host == "www.mastersol.tech"
      ? "https://gwt.mastersol.tech/h5"
      : "https://gatdata-test-pe.jinglewill.com/h5",
  // timeout: 900000,
  transformResponse: [
    function(data) {
      try {
        // 如果转换成功则返回转换的数据结果
        return jsonBig.parse(data);
      } catch (err) {
        // 如果转换失败，则包装为统一数据格式并返回
        return {
          data,
        };
      }
    },
  ],
});

let platform;

function checkPWAInstallation() {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      if (registrations.length > 0) {
        // PWA已安装的逻辑处理
        platform = "h5_setting";
        console.log("PWA is installed.");
      } else {
        // PWA未安装的逻辑处理
        console.log("PWA is not installed.");
        platform = "h5";
      }
    })
    .catch((error) => {
      console.error("Error checking PWA installation:", error);
    });
}

//http request 拦截器
service.interceptors.request.use(
  (config) => {
    if (config.type == "upload") {
      config.headers = {
        "Content-Type": "multipart/form-data",
        source: "MasterSol",
      };
    } else {
      checkPWAInstallation();
      let html = document.getElementsByTagName("html")[0];
      var oldWidth = html.clientWidth || document.documentElement.clientWidth;
      config.data = JSON.stringify({
        ...config.data,
        access_token: localStorage.getItem("token") || "",
        adjust_id: localStorage.getItem("adjust_id") || "",
        platform: oldWidth >= 800 ? "web" : platform,
      });
      config.headers = {
        "Content-Type": "application/json",
        source: "MasterSol",
      };
    }
    return config;
  },
  (error) => {
    return error;
  }
);

service.interceptors.response.use((response) => {
  let html = document.getElementsByTagName("html")[0];
  var oldWidth = html.clientWidth || document.documentElement.clientWidth;
  if (response.data.code == 400114) {
    storage.localStorageClearByLoginOut()
    if (oldWidth >= 800) {
      Message.error("El inicio de sesión ha caducado");
    } else {
      Toast("El inicio de sesión ha caducado");
    }
    setTimeout(() => {
      context.$router.push("/home");
      window.location.reload();
    }, 2000);
  }
  if (response.data.code !== 0) {
    if (oldWidth >= 800) {
      Message.error(response.data.message);
    } else {
      Toast(response.data.message);
    }
  }
  return response;
});

export default service;
